import React, { useCallback, useState } from 'react'
import { isEmptyString } from '../../../../utils/string-utils'
import { IconButton, Tooltip } from '@mui/material'
import GatewayModal from './gateway-modal'
import DeviceHubIcon from '@mui/icons-material/DeviceHub'

export interface ViewGatewayInfoModalTriggerProps {
  strategyId: string
  strategyName: string
  isApiConnected: boolean
  gatewayInfoUrl: string | null
  gatewayCommandUrl: string | null
}

const ViewGatewayInfoModalTrigger: React.FC<ViewGatewayInfoModalTriggerProps> = (props) => {
  const { strategyId, strategyName, isApiConnected, gatewayInfoUrl, gatewayCommandUrl } = props
  const isDisabled = !isApiConnected || isEmptyString(gatewayInfoUrl)

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const openModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setIsModalOpen(false)
  }, [])

  return (
    <>
      <GatewayModal
        open={isModalOpen}
        onClose={closeModal}
        strategyId={strategyId}
        title={`${strategyName} Gateway Info`}
        dataUrl={gatewayInfoUrl}
        postUrl={gatewayCommandUrl}
      />

      <Tooltip title='View gateway info'>
        <span>
          <IconButton size='small' disabled={isDisabled} onClick={openModal}>
            <DeviceHubIcon/>
          </IconButton>
        </span>
      </Tooltip>
    </>
  )
}

export default React.memo(ViewGatewayInfoModalTrigger)
